import { render } from "./SliderModal.vue?vue&type=template&id=44f3a95a&scoped=true"
import script from "./SliderModal.vue?vue&type=script&lang=js"
export * from "./SliderModal.vue?vue&type=script&lang=js"

import "./SliderModal.vue?vue&type=style&index=0&id=44f3a95a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f3a95a"]])

export default __exports__